import { motion } from 'framer-motion';
import { ReactNode } from 'react';

export const POrgPageContainer = ({ children }: { children: ReactNode }) => {
  return (
    <motion.div
      className="w-full"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ delay: 0.25, duration: 0.35 }}
    >
      {children}
    </motion.div>
  );
};
